import { createFileRoute } from "@tanstack/react-router";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useQueryState, parseAsBoolean } from "nuqs";
import OrderCreateForm from "./-form";
import { BulkOrderCrumbs } from "../-crumbs";

export const Route = createFileRoute(
  "/_private/_practice-360/bulk-order/create",
)({
  component: BulkOrderCreatePage,
});

function BulkOrderCreatePage() {
  const [isReorder] = useQueryState(
    "is_reorder",
    parseAsBoolean.withDefault(false),
  );
  const title = isReorder ? "Bulk Reorder" : "Bulk Order";

  return (
    <div>
      <title>Create Bulk Order - Legrande Health Portal</title>
      <BulkOrderCrumbs canEdit={true} isReorder={isReorder} />

      <Card>
        <CardHeader>
          <CardTitle>Create {title}</CardTitle>
          <CardDescription>
            Select your entity and payment method to get started.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <OrderCreateForm isReorder={isReorder} />
        </CardContent>
      </Card>
    </div>
  );
}
